import React from "react";
import { Link } from "react-router-dom";
import { formatContentAuthoringMode } from "../constants/productCatalogue";

export default function ProductCard({ system, actionLabel = "Open system" }) {
  const contentAuthoringStatus = system.key === "unityLearning"
    ? formatContentAuthoringMode()
    : "";

  return (
    <article className={`pa-product-card is-${system.tone || "blue"}`}>
      <div className="pa-product-card__top">
        <div className="pa-product-card__heading">
          <span className="pa-product-card__icon"><img src={system.icon} alt="" aria-hidden="true" /></span>
          <h3>{system.displayName}</h3>
        </div>
        <span className="pa-status-pill is-success"><i />Allocated</span>
      </div>
      <p>{system.description}</p>
      <dl>
        <div><dt>Workspace role</dt><dd>{system.workspaceRole}</dd></div>
        <div><dt>System role</dt><dd>{system.systemRole || system.role}</dd></div>
        <div className="pa-product-card__workspace"><dt>Workspace</dt><dd>{system.workspace}</dd></div>
        {system.key === "unityLearning" ? (
          <div className="pa-product-card__content-mode">
            <dt>Content authoring</dt>
            <dd>
              <span>{contentAuthoringStatus}</span>
            </dd>
          </div>
        ) : null}
      </dl>
      <div className="pa-product-card__action">
        <Link to={system.launchRoute}>{actionLabel} <span aria-hidden="true">{actionLabel === "Open system" ? "›" : "→"}</span></Link>
        {system.lastOpened ? <small>Last opened {system.lastOpened}</small> : null}
      </div>
    </article>
  );
}
